var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "_flexcol _gap-6" },
    _vm._l(_vm.exploreCategories, function (category) {
      return _c(
        "div",
        {
          key: category.sectionKey,
          attrs: { "data-qa": `explore-section:${category.title}` },
        },
        [
          _c(
            "home-section-title",
            { staticClass: "_mb-1", attrs: { "icon-name": category.icon } },
            [_vm._v(_vm._s(category.title))]
          ),
          _vm._v(" "),
          _c("project-explorer", {
            attrs: {
              categories: category.items,
              "default-category-key": category.defaultCategoryKey,
              source: "homepage",
            },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }